import { NotificationsActions, NotificationsActionTypes } from "./notifications.action";
import { NotificationCounters, NotificationsCount } from "./notifications.model";

export interface NotificationsState {
  count: NotificationsCount,
  error: string | null,
  // SAN-1428 — null until the first successful fetch, and always null while
  // notification_centre_enabled is off (no badge renders from null).
  counters: NotificationCounters | null
}

export const initialState: NotificationsState = {
  count: {
    pendingConnectionCount: 0,
    sentConnectionCount: 0,
    unreadNotificationCount: 0,
    unreadMessageCount: 0,
    pendingAcceptanceMentorHoursCount: 0,
    pendingDocumentsUploadCount: 0,
    pendingProgramFormSubmissionCount:0,
    pendingAcceptanceMeetingCount: 0
  },
  error: "",
  counters: null
};

function setNotificationsSuccess(state: NotificationsState = initialState, data: NotificationsCount): NotificationsState {
  return {
    ...state,
    count: data,
    error: ""
  };
}

function setNotificationsFault(state: NotificationsState = initialState, data: string): NotificationsState {
  return {
    ...state,
    count: null,
    error: data

  };
}

function markAllReadNotificationsSuccess(state: NotificationsState = initialState, data: NotificationsCount): NotificationsState {
  return {
    ...state,
    count: data,
    error: ""
  };
}

function markAllReadNotificationsFault(state: NotificationsState = initialState, data: string): NotificationsState {
  return {
    ...state,
    count: null,
    error: data

  };
}

function connectionRequestHandled(state: NotificationsState): NotificationsState {
  const less = (n: number) => Math.max(0, (n || 0) - 1);
  return {
    ...state,
    count: state.count ? { ...state.count, pendingConnectionCount: less(state.count.pendingConnectionCount) } : state.count,
    counters: state.counters
      ? {
        ...state.counters,
        connections: less(state.counters.connections),
        // The connections term is in the bell only while not muted (SAN-1478).
        bell: state.counters.inAppMuted?.includes('connectionRequests') ? state.counters.bell : less(state.counters.bell),
      }
      : state.counters,
  };
}

export function notificationsReducer(state: NotificationsState = initialState, action: NotificationsActions): NotificationsState {
  switch (action.type) {
    case NotificationsActionTypes.SetNotificationsCountSuccess:
      return setNotificationsSuccess(state, action.payload);
    case NotificationsActionTypes.SetNotificationsCountFault:
      return setNotificationsFault(state, action.payload);
    case NotificationsActionTypes.MarkAllReadNotificationsSuccess:
      return markAllReadNotificationsSuccess(state, action.payload);
    case NotificationsActionTypes.MarkAllReadNotificationsFault:
      return markAllReadNotificationsFault(state, action.payload);
    case NotificationsActionTypes.FetchNotificationCountersSuccess:
      return { ...state, counters: action.payload };
    case NotificationsActionTypes.ConnectionRequestHandled:
      return connectionRequestHandled(state);
    default:
      return state;
  }
}


